import { AdminCertificatesSettingsRow } from "../../../../models/admin-certificates-settings.models";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { MouseEvent } from "react";

type Props = {
  row: AdminCertificatesSettingsRow;
  onEditRow: (row: AdminCertificatesSettingsRow) => void;
};

const EditRowButton = ({ row, onEditRow }: Props) => {
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onEditRow(row);
  };

  return (
    <div className="flex h-full min-h-10 items-center justify-center">
      <button
        type="button"
        aria-label={`Edit ${row.CERTIFICATE_NAME ?? `row ${row.ID}`}`}
        title="Edit"
        data-test={`admin-certificates-settings-edit-${row.ID}`}
        className="inline-flex h-6 w-6 items-center justify-center text-green transition-colors hover:bg-[#E9F4F3]"
        onClick={handleClick}
        onDoubleClick={(event) => event.stopPropagation()}
      >
        <PencilSquareIcon className="h-4 w-4" />
      </button>
    </div>
  );
};

export default EditRowButton;
